import Router from "next/router"
import queryString, { StringifiableRecord } from "query-string"
import { DEFAULT_LANG, Languages } from "@providers"

import type { LanguageISO } from "@providers"

export const getHistoryQuery = () => {
  return queryString.parse(window.location.search)
}

// @ts-ignore
export const createHistoryQuery = (params) => {
  return `?${queryString.stringify(params)}`
}

interface PushParams {
  href: string
  query?: StringifiableRecord
}

export const isExistLangInUri = (uri: string): boolean => {
  let isExist = false

  Object.values(Languages).forEach((lang) => {
    if (new RegExp(`^/${lang.id}/`, "i").test(uri)) {
      isExist = true
      return false
    }
  })
  return isExist
}

export const getLangFromUri = (uri: string): LanguageISO => {
  let result: LanguageISO = DEFAULT_LANG

  Object.values(Languages).forEach((lang) => {
    if (new RegExp(`^/${lang.id}/`, "i").test(uri)) {
      result = lang.id as LanguageISO
      return false
    }
  })
  return result
}

export const push = async ({ href, query = {} }: PushParams) => {
  if (Object.keys(query).length > 0) {
    await Router.push(`${href}${createHistoryQuery(query)}`)
  }
  await Router.push(`${href}`)
}

export const isJournalLocationPathname = () => {
  return /\/[a-z]{2}\/journal/g.test(window.location.pathname)
}
